module.exports = __webpack_public_path__ + "static/media/Birdwatcher.71debe49.jpg";